import type { SchemaLoanRequestResolver_GetUnreadConsorsNotes } from 'cpool-tables/backend-resolvers';

export const buildBankReportRecord = (
    data: SchemaLoanRequestResolver_GetUnreadConsorsNotes,
): Record<string, string> => {
    return Object.fromEntries(
        data
            .filter(
                (entry): entry is typeof entry & { subscriptionIdentifier: string } =>
                    typeof entry.subscriptionIdentifier === 'string',
            )
            .map((entry) => [entry.loanRequestId, entry.subscriptionIdentifier] as const),
    );
};
